import { render } from "./textEdit.vue?vue&type=template&id=374cf402"
import script from "./textEdit.vue?vue&type=script&lang=js"
export * from "./textEdit.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__